import { ref, toRef, computed, watch } from 'vue'

export const usePagination = (props) => {
    const maxData = toRef(props, 'maxData')
    const data = toRef(props, 'data')
    const totalPages = ref(1)
    const currentPage = ref(1)
    const paginatedData = computed(() =>
        data.value.filter((d) => {
            if (Array.isArray(d)) {
                return d.some((each) => each.page === currentPage.value)
            } else {
                return d.page === currentPage.value
            }
        })
    )
    const paginatedPages = computed(() => {
        if (totalPages.value > 7) {
            return [
                {
                    page: '1',
                    highlight: true
                },
                {
                    page: '2',
                    highlight: false
                },
                {
                    page: '3',
                    highlight: false
                },
                {
                    page: '...',
                    highlight: false
                },
                {
                    page: `${totalPages.value - 2}`,
                    highlight: false
                },
                {
                    page: `${totalPages.value - 1}`,
                    highlight: false
                },
                {
                    page: `${totalPages.value}`,
                    highlight: false
                }
            ]
        } else {
            return Array.from({ length: totalPages.value }, (_, index) => ({
                page: `${index + 1}`,
                highlight: index === 0 ? true : false
            }))
        }
    })

    watch(
        () => data.value,
        () => {
            _initPagination()
        }
    )
    watch(
        () => currentPage.value,
        (page) => {
            const currentPaginatedPage = paginatedPages.value.find((p) => p.page == page)

            if (currentPaginatedPage) {
                paginatedPages.value.forEach((p) => {
                    if (p.page === currentPaginatedPage.page) {
                        p.highlight = true
                    } else {
                        p.highlight = false
                    }
                })
            } else {
                paginatedPages.value.forEach((p) => {
                    if (p.page === '...') {
                        p.highlight = true
                    } else {
                        p.highlight = false
                    }
                })
            }
        }
    )
    ;(() => {
        if (!maxData.value || !data.value) {
            throw new Error('need to pass in maxData: number; and data: [{}]')
        }

        _initPagination()
    })()

    function nextPage() {
        if (currentPage.value + 1 > totalPages.value) {
            currentPage.value = 1
        } else {
            currentPage.value += 1
        }
    }
    function prevPage() {
        if (currentPage.value - 1 <= 0) {
            currentPage.value = totalPages.value
        } else {
            currentPage.value -= 1
        }
    }

    function _initPagination() {
        let page = 1
        data.value.forEach((d, i) => {
            if (i >= page * maxData.value) {
                page += 1
            }

            if (Array.isArray(d)) {
                d.forEach((each) => (each.page = page))
            } else {
                d.page = page
            }
        })

        totalPages.value = page
    }

    return {
        totalPages,
        currentPage,
        paginatedData,
        paginatedPages,
        nextPage,
        prevPage
    }
}
